const MediaFormatEnum = Object.freeze({
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    DOC: 'DOC'
});

export default MediaFormatEnum;
